export default __webpack_public_path__ + "0c1d0a94446d65e1b69a4b7a134d67b5.svg";